import { render, staticRenderFns } from "./TreeArea.vue?vue&type=template&id=bc45776a&"
import script from "./TreeArea.vue?vue&type=script&lang=js&"
export * from "./TreeArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc45776a')) {
      api.createRecord('bc45776a', component.options)
    } else {
      api.reload('bc45776a', component.options)
    }
    module.hot.accept("./TreeArea.vue?vue&type=template&id=bc45776a&", function () {
      api.rerender('bc45776a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/components/TreeArea.vue"
export default component.exports